export function extensionFromName(name) {
  if (typeof name !== 'string' || !name) return ''
  const i = name.lastIndexOf('.')
  if (i <= 0 || i === name.length - 1) return ''
  return name.slice(i + 1).toLowerCase()
}
